export default __webpack_public_path__ + "static/media/BlissLogo.c34be381.jpeg";